export default __webpack_public_path__ + "static/media/finance-topic4.32416ef8.png";